import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/
export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.08887 13.439V12.439H18.0889V13.439H7.08887Z" fill="#C1AF86" />
      </svg>
    </Icons>
  );
}
